import { render } from "./NewInventoryAssembly.vue?vue&type=template&id=f812352e"
import script from "./NewInventoryAssembly.vue?vue&type=script&lang=js"
export * from "./NewInventoryAssembly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__